import { Routes, Route, Navigate } from "react-router-dom";
import PageLayout from "../components/PageLayout";
import NotFound from "./NotFound";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "./Login";
import MsalInstance from "../authorization/AuthorizationProvider";
import Homepage from "./Homepage";
import Datasets from "./Datasets";
import LocatorDataset from "./Datasets/Locators/LocatorDataset";
import ScrewDataset from "./Datasets/Screws/ScrewDataset";
import Model from "./Models";
import LocatorModel from "./Models/Locators/LocatorModel";
import ScrewModel from "./Models/Screws/ScrewModel";
import Predict from "./Predict";
import PredictScrews from "./Predict/PredictScrews";
import Settings from "./Settings";
import Help from "./Help";
import EvaluationDashboard from "./Evaluate";
import EvaluateLocators from "./Evaluate/EvaluateLocators";
import EvaluateScrews from "./Evaluate/EvaluateScrews";
import Customers from "./Customers/Customers";
import BlockedPage from "./Blocked/BlockedPage";
import userHook from '../hooks/userHook';

const AppEntry = () => {
  const { isAdmin, isClient, loading, isBlocked } = userHook();

  return (
    <MsalProvider instance={MsalInstance}>
      <PageLayout blocked={!loading && isBlocked}>
        <AuthenticatedTemplate>
          {!loading && isBlocked ? (
            <BlockedPage />
          ) : (
          <Routes>
            <Route path="/" 
              element={loading ? <div>Loading...</div> : <Homepage />}
            />
            <Route
              path="/datasets"
              element={loading ? <div>Loading...</div> : (isAdmin ? <Datasets /> : <Navigate to="/" />)}
            />
            <Route
              path="/dataset/locators/:page"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <LocatorDataset /> : <Navigate to="/" />)}
            />
            <Route
              path="/dataset/screws/:page"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <ScrewDataset /> : <Navigate to="/" />)}
            />
            <Route
              path="/models"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <Model /> : <Navigate to="/" />)}
            />
            <Route
              path="/model/locators"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <LocatorModel /> : <Navigate to="/" />)}
            />
            <Route
              path="/model/screws"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <ScrewModel /> : <Navigate to="/" />)}
            />
            <Route
              path="/predict"
              element={<Navigate to="/predict/locators" replace />}
            />
            <Route
              path="/predict/locators"
              element={loading ? <div>Loading...</div> : ( isClient ? <Predict /> : <Navigate to="/" />)}
            />
            <Route
              path="/predict/screws"
              element={loading ? <div>Loading...</div> : ( isClient ? <PredictScrews /> : <Navigate to="/" />)}
            />
            <Route
              path="/evaluate"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <EvaluationDashboard /> : <Navigate to="/" />)}
            />
            <Route
              path="/evaluate/locators"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <EvaluateLocators /> : <Navigate to="/" />)}
            />
            <Route
              path="/evaluate/screws"
              element={loading ? <div>Loading...</div> : ( isAdmin ? <EvaluateScrews /> : <Navigate to="/" />)}
            />
            <Route path="/users" element={<Navigate to="/customers" replace />} />
            <Route
              path="/customers"
              element={loading ? <div>Loading...</div> : (isAdmin ? <Customers /> : <Navigate to="/" />)}
            />
            <Route path="/help" element={<Help />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          )}
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Routes>
            <Route path="*" element={<Login />} />
          </Routes>
        </UnauthenticatedTemplate>
      </PageLayout>
    </MsalProvider>
  );
};

export default AppEntry;